
import React, { useEffect, useRef, useState } from 'react';
import { certifications } from '@/data/certifications';
import { sortCertifications } from '@/utils/certificationUtils';
import CertificationsList from './certifications/CertificationsList';

const CertificationsSection: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => {
      observer.disconnect();
    };
  }, []);

  const sortedCertifications = sortCertifications(certifications);
  
  return (
    <section id="certifications" className="py-20 relative overflow-hidden" ref={sectionRef}>
      <div className="cert-vector cert-vector-1"></div>
      <div className="cert-vector cert-vector-2"></div>
      
      <div className="section-container relative z-10">
        <div className={`max-w-3xl mx-auto transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
        }`}>
          <p className="heading-highlight mb-2 animate-pulse-slow relative">Professional Growth</p>
          <h2 className="text-3xl font-bold mb-4">Certifications & Achievements</h2>
          
          <p className="text-muted-foreground mb-10">
            I continuously invest in my professional development through focused learning and certifications.
            Here are the key credentials that have enhanced my technical expertise.
          </p>
          
          <CertificationsList certifications={sortedCertifications} isVisible={isVisible} />
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
